import * as React from 'react';

const ConnectionSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 48" fill="none" {...props}>
        <path
            clipRule="evenodd"
            d="M13.293 21.98l12.728 12.727-4.95 4.95A9 9 0 018.343 26.929l4.95-4.95z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.343 39.657L1 47M21.778 20.565l-4.242 4.243M27.435 26.222l-4.243 4.242M17.85 35.072L21.778 39M9 26.222l4.063 4.063L9 26.222z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M34.232 25.996L21.504 13.268l4.95-4.95a9 9 0 1112.728 12.728l-4.95 4.95z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M38 22L26 10M39.182 8.318L47 1"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

ConnectionSvg.displayName = 'ConnectionSvg';
export default ConnectionSvg;
